import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import AmountItem from './AmountItem';
import { messages } from './messages';
import {
  calculatePercentWidthForAvg,
  calculatePercentWidthForNationalAvg,
} from '../../../utils/scholarships';

export default function AverageFederalStudentLoanAmount({
  costsData,
  tuitionStatistics,
}) {
  const loanValue = get(costsData, 'averageAmountOfAid.studentLoan.value', 0);
  const loanAverageValue = get(
    tuitionStatistics,
    'FOUR_YEAR.AVERAGES.federalStudentLoan',
    0,
  );
  const grantWidth = calculatePercentWidthForAvg(
    costsData,
    tuitionStatistics,
    'studentLoan',
    'federalStudentLoan',
  );
  const averageWidth = calculatePercentWidthForNationalAvg(
    tuitionStatistics,
    'federalStudentLoan',
  );

  return (
    <AmountItem
      value={loanValue}
      legend={messages.avgFedLoanAmount}
      width={grantWidth}
      averageWidth={averageWidth}
      averageValue={loanAverageValue}
      information={messages.loanInformation}
      description={messages.loanDescription}
    />
  );
}

AverageFederalStudentLoanAmount.propTypes = {
  costsData: PropTypes.object,
  tuitionStatistics: PropTypes.object,
};
